import Search from "antd/lib/input/Search";
import { styled } from "twin.macro";

export const SearchWrapper = styled.div`
	.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child {
		display: none;
	}
`;

export const SearchInput = styled(Search)`

`
